<div class="container">
  <mat-toolbar class="mat-toolbar">
    <img
      src="/public/logos/logo_v.svg"
      alt="App Logo"
      class="app-logo"
      (click)="goHome()"
    />

    @if (showNavLinks()) {
      <nav class="primary-nav" aria-label="Main navigation">
        <a
          routerLink="/home"
          routerLinkActive="primary-nav__link--active"
          [routerLinkActiveOptions]="{ exact: false }"
          class="primary-nav__link"
        >{{ 'app.header.home' | translate }}</a>
        <a
          routerLink="/family"
          routerLinkActive="primary-nav__link--active"
          [routerLinkActiveOptions]="{ exact: false }"
          class="primary-nav__link"
        >{{ 'app.header.navFamily' | translate }}</a>
        @if (showPatrolNavLink()) {
        <a
          routerLink="/patrol"
          routerLinkActive="primary-nav__link--active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="primary-nav__link"
        >{{ 'app.header.navPatrol' | translate }}</a>
        }
        @if (showIdentityNavLink()) {
          <a
            routerLink="/identity"
            routerLinkActive="primary-nav__link--active"
            [routerLinkActiveOptions]="{ exact: false }"
            class="primary-nav__link primary-nav__link--identity"
          >
            {{ 'app.header.navIdentity' | translate }}
            @if (identityNavBadgeCount() > 0) {
              <span class="primary-nav__badge" [attr.aria-label]="identityNavBadgeCount()">
                {{ identityNavBadgeCount() }}
              </span>
            }
          </a>
        }
      </nav>
    }

    <span class="spacer"></span>

    @if (user(); as currentUser) {
      <div class="right-content">
        @if (showUpgradeInToolbar() && isBasicAccount(currentUser)) {
          <div class="upgrade-container" role="button" tabindex="0">
            <div class="icon-wrapper" role="img" aria-hidden="true"></div>
            <div class="upgrade-text">{{ 'app.header.upgrade' | translate }}</div>
            <span class="lock-icon" role="img" aria-hidden="true"></span>
          </div>
        }

        <div class="user-menu-wrap">
          <button
            type="button"
            class="user-menu-trigger"
            [class.user-menu-trigger--open]="showUserMenu()"
            [attr.aria-expanded]="showUserMenu()"
            [attr.aria-haspopup]="true"
            [attr.aria-label]="'app.header.profile' | translate"
            (click)="toggleUserMenu($event)"
          >
            <app-user-card [user]="currentUser" [compact]="true" />
          </button>

          @if (showUserMenu()) {
            <div
              class="header-user-menu"
              role="menu"
              (click)="$event.stopPropagation()"
            >
              <div class="header-user-menu__identity">
                <p class="header-user-menu__name">
                  {{ currentUser.personalData?.firstName }}
                  {{ currentUser.personalData?.lastName }}
                </p>
                <p class="header-user-menu__meta">
                  {{
                    'app.header.kidsCounter'
                      | translate: { counter: kidsCount() }
                  }}
                </p>
              </div>

              <div class="header-user-menu__actions">
                @if (showUpgradeInMenu() && isBasicAccount(currentUser)) {
                  <button type="button" class="header-user-menu__action header-user-menu__action--upgrade" role="menuitem">
                    <span class="header-user-menu__action-icon header-user-menu__action-icon--upgrade" aria-hidden="true"></span>
                    <span>{{ 'app.header.upgrade' | translate }}</span>
                  </button>
                }

                @if (showIdentityMenuItem()) {
                  <button
                    type="button"
                    class="header-user-menu__action"
                    role="menuitem"
                    (click)="toIdentity()"
                  >
                    <img
                      class="header-user-menu__action-icon header-user-menu__action-icon--img"
                      src="/public/svgs/identity-id.svg"
                      alt=""
                      width="16"
                      height="16"
                      aria-hidden="true"
                    />
                    <span>{{ 'app.header.navIdentity' | translate }}</span>
                    @if (identityNavBadgeCount() > 0) {
                      <span class="header-user-menu__badge">{{ identityNavBadgeCount() }}</span>
                    }
                  </button>
                }

                <button
                  type="button"
                  class="header-user-menu__action"
                  role="menuitem"
                  (click)="toFamily()"
                >
                  <img
                    class="header-user-menu__action-icon header-user-menu__action-icon--img"
                    src="/public/svgs/family-together.svg"
                    alt=""
                    width="16"
                    height="16"
                    aria-hidden="true"
                  />
                  <span>{{ 'app.header.navFamily' | translate }}</span>
                </button>

                <button
                  type="button"
                  class="header-user-menu__action"
                  role="menuitem"
                  (click)="toProfile()"
                >
                  <svg class="header-user-menu__action-icon" viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                    />
                    <path
                      d="M4 20c0-3.314 3.582-6 8-6s8 2.686 8 6"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                  <span>{{ 'app.header.profile' | translate }}</span>
                </button>

                <button
                  type="button"
                  class="header-user-menu__action header-user-menu__action--logout"
                  role="menuitem"
                  (click)="logout()"
                >
                  <img
                    class="header-user-menu__action-icon header-user-menu__action-icon--img"
                    src="/public/svgs/logout.svg"
                    alt=""
                    width="16"
                    height="16"
                    aria-hidden="true"
                  />
                  <span>{{ 'app.header.logout' | translate }}</span>
                </button>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </mat-toolbar>
</div>
